import CalendarItemEvent from '@berlitzplatforms/micro.ui.calendar-item-event'
import Spacer from '@berlitz/spacer'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

const ScheduleListLoader: React.FC = () => {
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>
          <Skeleton width={130} height={34} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '8px' }}>
            <Skeleton width={60} height={12} />
            <Skeleton width={140} height={12} />
          </div>
          <div>
            <Skeleton width={44} height={38} />
          </div>
        </div>
      </div>

      <Spacer size="md" />
      <Skeleton width={180} height={24} />
      <Spacer size="md" />

      <CalendarItemEvent loading />
      <br />
      <CalendarItemEvent loading />
      <br />
      <CalendarItemEvent loading />

      <Spacer size="xxxl" />
    </>
  )
}

export default ScheduleListLoader
